import { createStore, applyMiddleware } from "redux";
import { getComposer } from "boot/compose";
import { createEpicMiddleware } from "redux-observable";
import * as epics from "store/epics";
import * as reducers from "store/reducers";
import { createEpicSubject, createRootEpic } from "boot/epics";
import { createRootReducer } from "boot/reducers";
import { routerMiddleware } from "connected-react-router";

const initStore = (dependencies, history) => {
  const composeMiddleware = getComposer();
  const epicMiddleware = createEpicMiddleware({ dependencies });
  const epic$ = createEpicSubject(epics);
  const rootEpic = createRootEpic(epic$);

  const initalState = !!window.__PRELOADED_STATE__
    ? window.__PRELOADED_STATE__
    : {};

  const rootReducer = createRootReducer(history, { ...reducers });

  const store = createStore(
    rootReducer,
    initalState,
    composeMiddleware(
      applyMiddleware(routerMiddleware(history), epicMiddleware)
    )
  );

  epicMiddleware.run(rootEpic);

  return store;
};

export default initStore;
